import type { LocationSource } from '../realtime/contracts';

const labelKeys = {
  Entered: 'LocationSource_Entered_Label',
  MobileApp: 'LocationSource_MobileApp_Label',
  MobileAppSms: 'LocationSource_MobileAppSms_Label',
  WebApp: 'LocationSource_WebApp_Label',
  AppleEed: 'LocationSource_AppleEed_Label',
  Aml: 'LocationSource_Aml_Label',
  GoogleEls: 'LocationSource_GoogleEls_Label',
} as const satisfies Record<LocationSource, string>;

export function locationSourceLabelKey(source: LocationSource): string {
  return labelKeys[source];
}
